import { i18n } from '../i18n/i18n'

import React, { Component } from 'react'
import workOrderService from '../services/workOrder.service'
import printService from '../services/print.service'
import confirmService from '../services/confirm.service'
import workOrderApi, { WorkOrderData } from '../apis/workOrder.api'
import inventoryApi from '../apis/inventory.api'
import standaloneCasesApi, {
  StandaloneCasesCreateRequest
} from '../apis/standaloneCases.api'
import { ConfirmParams } from '../components/Confirm/Confirm.state'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import InputText from '../components/InputText'
import PageHeading from '../components/PageHeading'
import Row from '../components/Row/Row'
import SearchPicker, { SearchPickerOption } from '../components/SearchPicker'
import { WatermarkHelper } from '../components/WatermarkHelper'

interface Props {
    onWorkOrderSelect: (workOrder: WorkOrderData | null) => void
}

interface State {
    workOrder: string
    workOrderId: number | null
    itemId: number | null
    quantity: string
    reference: string
    workOrders: WorkOrderData[]
}

export default class StandaloneCaseCreateForm extends Component<Props, State> {
  initialState = {
    workOrder: '',
    workOrderId: null,
    itemId: null,
    quantity: '',
    reference: '',
    workOrders: []
  }

  constructor (props: Props) {
    super(props)
    this.state = this.initialState
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleWorkOrderSearch = this.handleWorkOrderSearch.bind(this)
    this.handleWorkOrderSelect = this.handleWorkOrderSelect.bind(this)
    this.handleWorkOrderBlur = this.handleWorkOrderBlur.bind(this)
    this.handleCreateClick = this.handleCreateClick.bind(this)
  }

  get workOrderOptions () {
    return workOrderService.searchOptions(this.state.workOrders)
  }

  printLabel (inventoryId: number) {
    inventoryApi.printCases(inventoryId, async markups => {
      if (!markups) return
      markups = await WatermarkHelper.applyWatermarks(markups)
      printService.printMarkups(markups)
      this.reset()
    })
  }

  reset () {
    this.setState(this.initialState)
    this.props.onWorkOrderSelect(null)
  }

  handleInputChange (name: string, value: string) {
    if (name === 'workOrder') {
      this.setState({ workOrderId: null, workOrder: value })
      this.props.onWorkOrderSelect(null)
    } else if (name === 'reference') this.setState({ reference: value })
    else if (name === 'quantity') this.setState({ quantity: value })
  }

  handleWorkOrderSearch (name: string, code: string) {
    workOrderApi.searchByCode(code, workOrders => {
      if (!workOrders) return
      this.setState({ workOrders })
    })
  }

  handleWorkOrderSelect (name: string, option: SearchPickerOption) {
    const workOrderId = option.id as number
    const workOrder = workOrderService.find(this.state.workOrders, workOrderId)
    if (!workOrder) return
    const { item } = workOrder
    if (!item) return
    this.props.onWorkOrderSelect(workOrder)
    const state = {
      workOrders: [],
      workOrderId,
      itemId: item.id,
      quantity: String(item.cpp)
    }
    this.setState(state)
  }

  handleWorkOrderBlur (name: string) {
    this.setState({ workOrders: [] })
  }

  handleCreateConfirm () {
    const { workOrderId, quantity, reference } = this.state
    const payload: StandaloneCasesCreateRequest = {}
    if (workOrderId) payload.workOrder = workOrderId
    if (quantity) payload.quantity = Number(quantity)
    if (reference) payload.reference = reference
    standaloneCasesApi.create(payload, inventory => {
      if (!inventory) return
      this.printLabel(inventory.id)
    })
  }

  handleCreateClick () {
    const confirm: ConfirmParams = {
      id: 1,
      question: i18n('Please review standalone case details above and then confirm'),
      confirmText: i18n('Confirm'),
      cancelText: i18n('Cancel'),
      onConfirm: () => this.handleCreateConfirm()
    }
    confirmService.push(confirm)
  }

  render () {
    return (
            <Card>
                <PageHeading
                    text={i18n('Create Standalone Case')}
                    doc="cases-create-standalone-cases"/>
                <Row column={3}>
                    <SearchPicker
                        name="workOrder"
                        value={this.state.workOrder}
                        options={this.workOrderOptions}
                        label={i18n('Work order')}
                        onSearch={this.handleWorkOrderSearch}
                        onChange={this.handleInputChange}
                        onSelect={this.handleWorkOrderSelect}
                        onBlur={this.handleWorkOrderBlur}/>
                    <InputText
                        name="quantity"
                        value={this.state.quantity}
                        label={i18n('Quantity')}
                        onChange={this.handleInputChange}/>
                    <InputText
                        name="reference"
                        value={this.state.reference}
                        label={i18n('Reference')}
                        onChange={this.handleInputChange}/>
                </Row>
                <CardButton
                    proceedText={i18n('Create')}
                    cancelText={i18n('Cancel')}
                    onProceedClick={this.handleCreateClick}/>
            </Card>
    )
  }
}
